<ion-header class="toolbar-no-padding">
  <app-header pageName="Select Device">
    <ion-buttons end>
      <ion-button slot="icon-only" fill="clear" data-cy="printOptionCloseBtn" (click)="onClose()" class="ion-padding-left">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </app-header>
</ion-header>

<div>
  <div>
    <p class="message">{{message}}</p>
  </div>
  <div class="buttons">
    <ion-button data-cy="printOptionOtherBtn" class="primary" (click)="selectOption('Other')">{{ 'OTHER' | translate }}</ion-button>
    <ion-button data-cy="printOptionPrintBtn" class="success" (click)="selectOption('true')"> {{ 'PRINT' | translate }} </ion-button>
  </div>
</div>